import React from "react";
import "./Checkbox.scss";

const Checkbox = ({ checked, onChange, children, className = "" }) => (
	<label className={`checkbox ${className}`.trim()}>
		<input
			type="checkbox"
			checked={checked}
			onChange={onChange}
		/>
		<span className="checkbox__mark" aria-hidden="true" />
		<span className="checkbox__label">{children}</span>
	</label>
);

export default Checkbox;
